import { lazy } from "react";

const ExercisePlan = lazy(() => import("@pages/ExercisePlan"));
const Dashboard = lazy(() => import("@pages/Dashboard"));
const DietPlan = lazy(() => import("@pages/DietPlan"));
const FitbotSupport = lazy(() => import("@pages/FitbotSupport"));
const Settings = lazy(() => import("@pages/Settings"));
const InviteMembers = lazy(() => import("@components/common/Modals/InviteMembers"));
const Preferences = lazy(() => import("@pages/editPreferences"));
const WeeklyMealPlanner = lazy(() => import("@features/diet/WeeklyMealPlaner"));
const AdviseMe = lazy(() => import("@pages/AdviseMe"));
const WeeklyMealSelection = lazy(() => import("@features/diet/WeeklyMealSelection"));
const PreferencesSelection = lazy(() => import("@features/diet/PreferenceSelection"));
const MealDescriptionModal = lazy(() => import("@features/diet/RecipieDetails"));
const ViewPlan = lazy(() => import("@features/exercise/WeeklyExerciseDetails/ViewPlan"));
const SleepCoach = lazy(() => import("@pages/SleepCoach"));
const Mindfullness = lazy(() => import("@pages/Mindfullness"));
const SleepCoachDashboard = lazy(() => import("@features/sleep/SleepCoachDashboard"));
const MindfulnessDashboard = lazy(() => import("@features/mindfulness/MindfulnessDashboard"));
const SubscribtionSuspended = lazy(() => import("@components/ui/SubscribtionSuspended"));
const SleepCoachPreferencesSelection = lazy(() => import("@features/sleep/sleepCoachPreferences"));
const MindfulnessPreferences = lazy(() => import("@features/mindfulness/MindfulnessPreferences"));
const QuizGameDashboard = lazy(() => import("@pages/QuizGame/Dashboard"));
const StartQuizGame = lazy(() => import("@features/QuizGame/StartQuizGame"));
const AllRanks = lazy(() => import("@features/QuizGame/AllRanks"));
const WeeklyLeaderBoard = lazy(() => import("@features/QuizGame/WeeklyLeaderBoard/WeeklyLeaderBoard"));
const QuizQuestionaire = lazy(() => import("@features/QuizGame/QuizQuestionares"));
const ChallengeFinished = lazy(() => import("@features/QuizGame/ChallengeFinshed"));
const WeeklyProgressTracker = lazy(() => import("@pages/WeeklyProgressTracking"));
const RanksWeekly = lazy(() => import("@features/weeklyProgressTracking/RanksWeekly"));
const MotivationCoach = lazy(() => import("@pages/MotivationalCoach"));
const Contact = lazy(() => import("@pages/ContactUs/Contact"));
const MedicalViewModal = lazy(() => import("@components/common/Modals/MedicalViewModal"));
const NoInternetConnection = lazy(() => import("@pages/NoInternet"));
const WeeklyExerciseDetails = lazy(() => import("@features/exercise/WeeklyExerciseDetails"));
const CreatePlansModal = lazy(() => import("@components/common/CreatePlansModal"));
const ViewAllRanks = lazy(() => import("@components/common/ViewAllRanks"));

export const routes = [
  {
    path: "/",
    component: Dashboard,
    activeCheck: true,
  },

  {
    path: "/first-forms",
    component: MedicalViewModal,
    activeCheck: true,
  },

  {
    path: "/dashboard/recipe-detail",
    component: MealDescriptionModal,
    activeCheck: true,
  },
  {
    path: "/diet-plan",
    component: DietPlan,
    activeCheck: true,
  },
  {
    path: "/diet-plan/weekly-meal-planner",
    component: WeeklyMealPlanner,
    activeCheck: true,
  },
  {
    path: "/diet-plan/select-meals",
    component: WeeklyMealSelection,
    activeCheck: true,
  },
  {
    path: "/diet-plan/preferences",
    component: PreferencesSelection,
    activeCheck: true,
  },
  {
    path: "/diet-plan/recipe-detail",
    component: MealDescriptionModal,
    activeCheck: true,
  },
  {
    path: "/exercise-plan",
    component: ExercisePlan,
    activeCheck: true,
  },
  {
    path: "/exercise-plan/execise-details",
    component: WeeklyExerciseDetails,
    activeCheck: true,
  },
  {
    path: "/exercise-plan/view-plan",
    component: ViewPlan,
    activeCheck: true,
  },
  {
    path: "/edit-preferences",
    component: Preferences,
    activeCheck: true,
  },
  {
    path: "/advise",
    component: AdviseMe,
    activeCheck: true,
  },
  {
    path: "/progress-tracker",
    component: WeeklyProgressTracker,
    activeCheck: true,
  },
  {
    path: "/progress-tracker/ranks",
    component: RanksWeekly,
    activeCheck: true,
  },
  {
    path: "/fitbot-support",
    component: FitbotSupport,
    activeCheck: true,
  },
  {
    path: "/sleep-coach",
    component: SleepCoach,
    activeCheck: true,
  },
  {
    path: "/sleep-coach-dashboard",
    component: SleepCoachDashboard,
    activeCheck: true,
  },
  {
    path: "/sleep-coach-ranks",
    component: ViewAllRanks,
    activeCheck: true,
  },
  {
    path: "/sleep-coach-preferences",
    component: SleepCoachPreferencesSelection,
    activeCheck: true,
  },
  {
    path: "/mindfulness",
    component: Mindfullness,
    activeCheck: true,
  },
  {
    path: "/quiz-game/start-quiz",
    component: StartQuizGame,
    activeCheck: true,
  },
  {
    path: "/quiz-game",
    component: QuizGameDashboard,
    activeCheck: true,
  },

  {
    path: "/quiz-game/ranks",
    component: AllRanks,
    activeCheck: true,
  },
  {
    path: "/quiz-game/weekly-Leader-board",
    component: WeeklyLeaderBoard,
    activeCheck: true,
  },
  {
    path: "/quiz-game/questionaires",
    component: QuizQuestionaire,
    activeCheck: true,
  },
  {
    path: "/quiz-game/challenge-finished",
    component: ChallengeFinished,
    activeCheck: true,
  },
  {
    path: "/motivational-coach",
    component: MotivationCoach,
    activeCheck: true,
  },
  {
    path: "/mindfulness-dashboard",
    component: MindfulnessDashboard,
    activeCheck: true,
  },
  {
    path: "/mindfulness-ranks",
    component: ViewAllRanks,
    activeCheck: true,
  },
  {
    path: "/renew-subscription",
    component: SubscribtionSuspended,
  },
  {
    path: "/mindfulness-preferences",
    component: MindfulnessPreferences,
    activeCheck: true,
  },
  {
    path: "/create-my-plans",
    component: CreatePlansModal,
    activeCheck: true,
  },
  {
    path: "/contact-us",
    component: Contact,
  },
  {
    path: "/invite-member",
    component: InviteMembers,
  },
  {
    path: "/settings",
    component: Settings,
  },
  {
    // path: "/no-connection",
    path: "/server-error",
    component: NoInternetConnection,
  },
    {
    path: "/my-account",
    component: Settings,
  },
];
